(function () {
  'use strict';

  var PAGE_SIZE = 18;
  var SEEN_WATCH_KEY = 'gettmi-home-watch-seen-v1';

  function root() {
    return document.querySelector('[data-gettmi-home-discovery]');
  }

  function config() {
    var node = document.querySelector('[data-gettmi-supabase]');
    if (!node) return null;
    var url = String(node.dataset.supabaseUrl || '').replace(/\/+$/, '');
    var key = String(node.dataset.supabaseKey || '');
    return url && key ? { url: url, key: key } : null;
  }

  function publicUrl(cfg, bucket, path) {
    if (!cfg || !bucket || !path) return '';
    return cfg.url + '/storage/v1/object/public/' +
      encodeURIComponent(String(bucket)) + '/' +
      String(path).split('/').map(encodeURIComponent).join('/');
  }

  function safeHttpUrl(value) {
    var candidate = String(value || '').trim();
    if (!candidate) return '';
    try {
      var parsed = new URL(candidate, window.location.origin);
      return parsed.protocol === 'https:' || parsed.protocol === 'http:' ? parsed.href : '';
    } catch (error) {
      return '';
    }
  }

  function detectPlatform(value) {
    try {
      var host = new URL(value).hostname.replace(/^www\./, '').toLowerCase();
      if (host === 'tiktok.com' || host.endsWith('.tiktok.com')) return 'tiktok';
      if (host === 'youtube.com' || host.endsWith('.youtube.com') || host === 'youtu.be') return 'youtube';
      if (host === 'instagram.com' || host.endsWith('.instagram.com')) return 'instagram';
    } catch (error) {
      return '';
    }
    return '';
  }

  function readSeenWatch() {
    try {
      return window.localStorage.getItem(SEEN_WATCH_KEY) || '';
    } catch (error) {
      return '';
    }
  }

  function writeSeenWatch(value) {
    try {
      window.localStorage.setItem(SEEN_WATCH_KEY, value);
    } catch (error) {
      /* Private browsing must not block navigation. */
    }
  }

  function setHomeTab(tab) {
    var mount = root();
    if (!mount) return;
    var selected = tab === 'watch' || tab === 'shop' ? tab : 'discover';
    state.activeTab = selected;
    document.body.classList.remove('gettmi-home-tab-discover', 'gettmi-home-tab-shop', 'gettmi-home-tab-watch');
    document.body.classList.add('gettmi-home-tab-' + selected);
    mount.querySelectorAll('[data-gettmi-home-tab]').forEach(function (button) {
      button.setAttribute('aria-selected', String(button.dataset.gettmiHomeTab === selected));
    });
    mount.querySelector('[data-gettmi-for-you-panel]').hidden = selected !== 'shop';
    mount.querySelector('[data-gettmi-clips-panel]').hidden = selected !== 'watch';
    if (selected === 'watch' && state.signature) {
      writeSeenWatch(state.signature);
      mount.querySelector('[data-gettmi-watch-unread]').hidden = true;
    }
  }

  function normaliseClip(cfg, row) {
    var thumbnail = safeHttpUrl(row.thumbnail_url);
    if (!thumbnail && row.thumbnail_path) {
      thumbnail = publicUrl(cfg, row.thumbnail_bucket || 'clips', row.thumbnail_path);
    }
    var external = safeHttpUrl(row.watch_url);
    var legacy = '';
    if (!external && row.video_path) {
      legacy = publicUrl(cfg, 'clip-videos', row.video_path);
    }
    if (!thumbnail || (!external && !legacy)) return null;
    return {
      id: String(row.id || row.watch_url || row.video_path || row.title || ''),
      title: String(row.title || ''),
      creator: String(row.handle || row.creator || ''),
      platform: String(row.platform || detectPlatform(external)).toLowerCase(),
      thumbnail: thumbnail,
      external: external,
      legacy: legacy,
      updatedAt: String(row.updated_at || row.created_at || '')
    };
  }

  /* Only a fallback now: every clip's frame is stored in our own bucket. If a new one
     ever arrives before that runs, take a 16:9 size. sddefault and hqdefault are 4:3,
     so YouTube bakes black bars into them for widescreen video. */
  var YOUTUBE_THUMBNAILS = ['hq720', 'maxresdefault', 'mqdefault'];

  function youtubeVariant(url, variant) {
    return url.replace(/\/(maxresdefault|sddefault|hqdefault|mqdefault)\.jpg/, '/' + variant + '.jpg');
  }

  function applyThumbnail(image, thumbnail) {
    if (!/^https:\/\/i\.ytimg\.com\/vi\//.test(thumbnail)) {
      image.src = thumbnail;
      return;
    }
    var step = 0;
    image.addEventListener('error', function () {
      step += 1;
      if (step < YOUTUBE_THUMBNAILS.length) {
        image.src = youtubeVariant(thumbnail, YOUTUBE_THUMBNAILS[step]);
      }
    });
    image.src = youtubeVariant(thumbnail, YOUTUBE_THUMBNAILS[0]);
  }

  function createTile(clip) {
    var tile = clip.external ? document.createElement('a') : document.createElement('button');
    tile.className = 'gettmi-clip-tile';
    if (clip.external) {
      tile.href = clip.external;
      tile.target = '_blank';
      tile.rel = 'noopener noreferrer';
    } else {
      tile.type = 'button';
      tile.dataset.gettmiLegacyClip = clip.legacy;
      tile.dataset.gettmiClipTitle = clip.title;
    }
    tile.setAttribute(
      'aria-label',
      (clip.title || 'Fashion clip') +
      (clip.creator ? ' by ' + clip.creator : '') +
      (clip.platform ? '. Opens in ' + clip.platform : '')
    );

    var image = document.createElement('img');
    image.alt = '';
    image.loading = 'lazy';
    image.decoding = 'async';
    image.width = 260;
    image.height = 364;
    applyThumbnail(image, clip.thumbnail);
    tile.appendChild(image);

    var shade = document.createElement('span');
    shade.className = 'gettmi-clip-tile__shade';
    tile.appendChild(shade);

    var title = document.createElement('strong');
    title.textContent = clip.title;
    tile.appendChild(title);

    var meta = document.createElement('span');
    meta.className = 'gettmi-clip-tile__meta';
    var play = document.createElement('b');
    play.textContent = '▷';
    var creator = document.createElement('small');
    creator.textContent = clip.creator;
    meta.appendChild(play);
    meta.appendChild(creator);
    tile.appendChild(meta);
    return tile;
  }

  function renderPage() {
    var mount = root();
    if (!mount || !state.clips.length) return;
    var grid = mount.querySelector('[data-gettmi-clips-grid]');
    var nextCount = Math.min(state.visibleCount + PAGE_SIZE, state.clips.length);
    for (var index = state.visibleCount; index < nextCount; index += 1) {
      grid.appendChild(createTile(state.clips[index]));
    }
    state.visibleCount = nextCount;
    mount.querySelector('[data-gettmi-clips-sentinel]').hidden = state.visibleCount >= state.clips.length;
    mount.querySelector('[data-gettmi-clips-end]').hidden = state.visibleCount < state.clips.length;
  }

  function showEmpty(message) {
    var mount = root();
    if (!mount) return;
    var stateNode = mount.querySelector('[data-gettmi-clips-state]');
    stateNode.classList.add('is-empty');
    stateNode.querySelector('p').textContent = message;
  }

  function loadClips() {
    var mount = root();
    var cfg = config();
    if (!mount || !cfg) {
      showEmpty('Clips are taking a break. Try again soon.');
      return;
    }
    window.fetch(
      cfg.url + '/rest/v1/home_clips?' +
      'select=id,title,creator,platform,handle,thumbnail_url,thumbnail_bucket,thumbnail_path,view_count,watch_url,video_path,sort_order,created_at,updated_at' +
      '&order=sort_order.asc',
      { headers: { apikey: cfg.key, Authorization: 'Bearer ' + cfg.key } }
    ).then(function (response) {
      if (!response.ok) throw new Error('clips');
      return response.json();
    }).then(function (rows) {
      state.clips = (Array.isArray(rows) ? rows : []).map(function (row) {
        return normaliseClip(cfg, row);
      }).filter(Boolean);
      state.signature = state.clips.map(function (clip) {
        return clip.id + ':' + clip.updatedAt;
      }).join('|');
      if (!state.clips.length) {
        showEmpty('New clips are coming soon.');
        return;
      }
      mount.querySelector('[data-gettmi-clips-state]').hidden = true;
      mount.querySelector('[data-gettmi-clips-grid]').hidden = false;
      if (state.activeTab === 'watch') writeSeenWatch(state.signature);
      mount.querySelector('[data-gettmi-watch-unread]').hidden =
        state.activeTab === 'watch' || !state.signature || readSeenWatch() === state.signature;
      renderPage();
    }).catch(function () {
      showEmpty('Clips are taking a break. Try again soon.');
    });
  }

  function openLegacyPlayer(source, title) {
    var mount = root();
    if (!mount || !source) return;
    var player = mount.querySelector('[data-gettmi-clip-player]');
    var video = player.querySelector('[data-gettmi-clip-video]');
    player.querySelector('[data-gettmi-clip-player-title]').textContent = title || 'Clip';
    video.src = source;
    player.hidden = false;
    document.documentElement.classList.add('gettmi-clip-player-open');
  }

  function closeLegacyPlayer() {
    var mount = root();
    if (!mount) return;
    var player = mount.querySelector('[data-gettmi-clip-player]');
    var video = player.querySelector('[data-gettmi-clip-video]');
    video.pause();
    video.removeAttribute('src');
    video.load();
    player.hidden = true;
    document.documentElement.classList.remove('gettmi-clip-player-open');
  }

  var state = {
    activeTab: 'discover',
    clips: [],
    signature: '',
    visibleCount: 0
  };

  document.addEventListener('click', function (event) {
    var mount = root();
    if (!mount || !event.target.closest) return;
    var tab = event.target.closest('[data-gettmi-home-tab]');
    if (tab) {
      setHomeTab(tab.dataset.gettmiHomeTab);
      mount.scrollIntoView({ block: 'start', behavior: 'smooth' });
      return;
    }
    var legacy = event.target.closest('[data-gettmi-legacy-clip]');
    if (legacy) {
      openLegacyPlayer(legacy.dataset.gettmiLegacyClip, legacy.dataset.gettmiClipTitle);
      return;
    }
    if (event.target.closest('[data-gettmi-close-clip-player]')) {
      closeLegacyPlayer();
    }
  });

  function boot() {
    var mount = root();
    if (!mount || mount.dataset.gettmiBooted === 'true') return;
    mount.dataset.gettmiBooted = 'true';
    setHomeTab('discover');
    var sentinel = mount.querySelector('[data-gettmi-clips-sentinel]');
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) renderPage();
      }, { rootMargin: '900px 0px' }).observe(sentinel);
    }
    loadClips();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
